import { render, staticRenderFns } from "./organizations-list.html?vue&type=template&id=6a9fc8c8&scoped=true&external"
import script from "./organizations-list.js?vue&type=script&lang=js&external"
export * from "./organizations-list.js?vue&type=script&lang=js&external"
import style0 from "./organizations-list.scss?vue&type=style&index=0&id=6a9fc8c8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9fc8c8",
  null
  
)

export default component.exports